/*----------------------------------------------------------------------------*\
    FORM.ELEMENTS.FILE-MULTI
    Multi file upload, using dropzone js
\*----------------------------------------------------------------------------*/

/**
 * Use strict as per:
 * http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
 */
'use strict';


/**
 * Check if oy object exists, otherwise create it
 */
var oy = oy || {};

var uploadUrl = '';

/**
 * Jshint global references
 * Please define all third party plugins that you use to not break jshinting
 */

/*global plupload */
/*global moxie */



/*  Component
\*----------------------------------------------------------------------------*/

oy.form.elements.fileMulti = {

    init: function () {
        if (oy.cutsMustard) {
            this.initPluploads();
        }
    },

    changeUploadUrl(newUrl){
        uploadUrl = newUrl;
    },

    setupPlupload: function ($plupload) {
        var self = this;
        var $browseFileButton = $plupload.querySelector('.js--plupload__browse-file');
        var $browseFolderButton = $plupload.querySelector('.js--plupload__browse-folder');
        var $startUploadButton = $plupload.querySelector('.js--plupload__start-upload');
        var $container = $plupload.querySelector('.js--plupload__zone');
        var $imagesList = $plupload.querySelector('.js--plupload__image-list');
        var $progressWrap = $plupload.querySelector('.js--plupload__progress');
        uploadUrl = $plupload.dataset.pluploadUrl;
        var $minPixelSize = $plupload.dataset.pluploadMinpixelsize;
        var $bgimage = $plupload.dataset.pluploadBgimage;
        var uploader = new plupload.Uploader({
            browse_button: $browseFileButton, // eslint-disable-line camelcase
            dragdrop: true,
            prevent_duplicates: true, // eslint-disable-line camelcase
            rename: false,
            sortable: false,
            quality: 5,
            views: {
                list: false,
                thumbs: true
            },
            drop_element: $container, // eslint-disable-line camelcase
            url: uploadUrl,
            headers: {
                'Accept': 'application/json'
            },
            filters: {
                mime_types: [ // eslint-disable-line camelcase
                    {
                        title: 'Image files', extensions: $plupload.dataset.pluploadExtensions
                    }
                ],

                max_file_size: $plupload.dataset.pluploadMaxsize // eslint-disable-line camelcase
            }
        });
        // add the dom-element to the uploader object, for reuse
        uploader.$imagesList = $imagesList;
        uploader.$container = $container;
        uploader.$minPixelSize = $minPixelSize;
        uploader.$bgimage = $bgimage;
        uploader.init();
        // if the browse-folder button is clicked, add attributes for the js-inserted <input type="file">
        if ($browseFolderButton) {
            $browseFolderButton.addEventListener('click', function () {
                var $input = $plupload.querySelector('input[type="file"]');

                $input.setAttribute('webkitdirectory', '');
                $input.setAttribute('mozdirectory', '');
                $input.setAttribute('odirectory', '');
                $input.setAttribute('msdirectory', '');
                $input.setAttribute('directory', '');
                // simulate a click on the <input type="file">
                $input.click();
            });
        }

        // if the regular
        $browseFileButton.addEventListener('click', function () {
            var $input = $plupload.querySelector('input[type="file"]');

            $input.removeAttribute('webkitdirectory', '');
            $input.removeAttribute('mozdirectory', '');
            $input.removeAttribute('odirectory', '');
            $input.removeAttribute('msdirectory', '');
            $input.removeAttribute('directory', '');
        });

        var $altLink = $container.querySelector('.js--plupload__alt-link');
        $altLink.addEventListener('click', function () {
            $browseFileButton.click();
        });

        // files are added, create thumbs and enable the start upload button
        uploader.bind('FilesAdded', function (uploader) {
            self.handlePluploadFilesAdded(uploader);
            uploader.$container.classList.add('has-files');
            $startUploadButton.disabled = false;
        });

        $startUploadButton.addEventListener('click', function () {
            uploader.start();
        });

        uploader.bind('BeforeUpload', function (uploader, file) {
            $startUploadButton.disabled = true;
            // Check if a file is not renamed or deleted
            if (file.getNative() && file.getNative().size === 0) {
                uploader.trigger('Error', {'code': -404, 'file': file});
            }
            uploader.settings.url = uploadUrl;
        });

        uploader.bind('UploadProgress', function (uploader, file) {
            var $loader = uploader.$imagesList.querySelector('[data-file-id="' + file.id + '"] .js--plupload__progress-bar');
            if ($loader) {
                $loader.style.width = file.percent + '%';
            }
            $progressWrap.innerHTML = oy.dictionary.upload.progress + ': ' + uploader.total.percent + '%';
        });

        uploader.bind('FileUploaded', function (uploader, file, response) {
            if (response.status === 200) {
                // upload succeeded, remove the thumb
                self.removeThumb(uploader, file);
            }
        });

        uploader.bind('UploadComplete', function (uploader, files) {
            $progressWrap.innerHTML = '';

            var failedFiles = [];
            for (var i = 0; i < uploader.files.length; ++i) {
                var file = files[i];
                if (file.status !== 5) {
                    failedFiles.push(file);
                }
            }

            var message = oy.dictionary.upload.uploadFinished;
            var buttons = [{
                text: oy.dictionary.upload.ok,
                action: function() {
                    oy.modal.closeModal(document, $plupload.dataset.modalId);
                }
            }];

            if (failedFiles.length) {
                if (failedFiles.length === 1) {
                    message += oy.dictionary.upload.fileNotReceived + ':';
                } else {
                    message += oy.dictionary.upload.filesNotReceived + ':';
                }
                message += '<ul>';

                for (var j = 0; j < failedFiles.length; ++j) {
                    message += '<li>' + failedFiles[j].name + '</li>';
                }
                message += '<ul>';


                // show an upload overview message in a modal
                oy.modal.openModal(document, $plupload.dataset.modalId, message, buttons, oy.dictionary.upload.uploadSucceeded);
            } else {
                $startUploadButton.disabled = true;
                setTimeout(function(){
                    uploader.$container.classList.remove('has-files');
                    oy.modal.openModal(document, $plupload.dataset.modalId, message, buttons, oy.dictionary.upload.uploadSucceeded);
                }, oy.settings.transitions.medium);
            }

            var evt = new CustomEvent('getUpdatedBackgrounds',true,true);
            document.dispatchEvent(evt);
        });

        uploader.bind('Error', function (uploader, error) {
            var showError = true,
                buttons,
                message;

            var modalButtons = {
                buttonOk: {
                    text: oy.dictionary.upload.ok,
                    action: function() {
                        oy.modal.closeModal(document, $plupload.dataset.modalId);
                    }
                },
                buttonCancel: {
                    text: oy.dictionary.upload.cancel,
                    action: function() {
                        oy.modal.closeModal(document, $plupload.dataset.modalId);
                    }
                },
                buttonRetry: {
                    text: oy.dictionary.upload.again,
                    action: function() {
                        var retryFile = uploader.getFile(error.file.id);
                        self.resetFile(retryFile);
                        oy.modal.closeModal(document, $plupload.dataset.modalId);
                        uploader.start();
                    }
                },
                buttonSkip: {
                    text: oy.dictionary.upload.skip,
                    action: function() {
                        self.removeThumb(uploader, error.file);
                        uploader.removeFile(error.file);
                        oy.modal.closeModal(document, $plupload.dataset.modalId);
                        uploader.start();
                    }
                },
                buttonAbort: {
                    text: oy.dictionary.upload.break,
                    action: function() {
                        oy.modal.closeModal(document, $plupload.dataset.modalId);
                    }
                }
            };

            switch (error.code) {
            case -404:
                // File renamed or deleted
                message = oy.dictionary.upload.fileRenamedOrDeleted + ': ' + error.file.name + '.';
                buttons = [modalButtons.buttonRetry, modalButtons.buttonSkip, modalButtons.buttonAbort];
                break;
            case -601: // File extension error
                message = oy.dictionary.upload.invalidExtension + ': ' + error.file.name + '.';
                buttons = [modalButtons.buttonOk];
                break;
            case -602: // Duplicate file error
                message = oy.dictionary.upload.fileAlreadyExists + ': ' + error.file.name;
                buttons = [modalButtons.buttonOk];
                showError = false;
                break;
            case -200: // HTTP Error
                message = oy.dictionary.upload.genericError + ': ' + error.file.name + '.<br>';
                buttons = [modalButtons.buttonRetry, modalButtons.buttonSkip, modalButtons.buttonAbort];
                break;
            case -600: // File size error
                message = oy.dictionary.upload.fileSizeError + ': ' + error.file.name + '.<br>';
                buttons = [modalButtons.buttonOk];
                break;

            default: // Generic error
                message = oy.dictionary.upload.genericError + ': ' + error.file.name + '.<br>';
                buttons = [modalButtons.buttonRetry, modalButtons.buttonSkip, modalButtons.buttonAbort];
                break;
            }

            if (showError === true) {
                // show a message in a modal
                oy.modal.openModal(document, $plupload.dataset.modalId, message, buttons, oy.dictionary.upload.genericError);
                uploader.stop();
            }
        });
    },

    handlePluploadFilesAdded: function (uploader) {
        var self = this;
        uploader.files = self.addPathToFiles(uploader.files);

        var wait = 250;
        var waitStart = 0;
        for (var i = 0; i < uploader.files.length; i++) {
            var file = uploader.files[i];
            if (file.size <= 1024) {
                // remove the file from the queue if size is too low
                uploader.removeFile(file.id);
            } else {
                if (!uploader.files[i].isLoaded) {
                    waitStart = waitStart + wait;
                    uploader.files[i].isLoaded = true;
                }
                // Show the client-side preview using the loaded File.
                self.showImagePreview(file, uploader, waitStart);
            }
        }
    },

    addPathToFiles: function (files) {
        var self = this;
        if (typeof files !== 'undefined') {
            for (var i = 0; i < files.length; i++) {
                files[i].path = self.getPathFromFile(files[i]);
            }
        }
        return files;
    },

    getPathFromFile: function (file) {
        var fileNative = file.getNative();
        var filePath = '';
        if (typeof fileNative !== 'undefined') {
            filePath = fileNative.fullPath || fileNative.webkitRelativePath;
        }
        return filePath;
    },

    getFolderFromFile: function (file) {
        var folder = '';

        if (typeof file.path !== 'undefined' && file.path !== '') {
            if(file.path.substring(0,1) !== '/'){
                file.path = '/' + file.path;
            }

            /**
             * Create array from path
             */
            var folderParts = file.path.split('/');

            /**
             * Remove filename from folderParts
             */
            folderParts.pop();

            folder = folderParts.join('/');
        }

        return folder;
    },

    createFolderView: function (folder, uploader) {
        var $folderList = uploader.$imagesList.querySelector('.js--file-multi__folder[data-rel="' + folder + '"] .js--file-multi__folder-list');

        if (!$folderList && folder !== '') {
            var subElements = '<strong>' + folder + '</strong><hr class="c-rule"/><ul class="o-layout o-layout--gutter-small  js--file-multi__folder-list"></ul>';
            var $folderElement = document.createElement('li');
            $folderElement.classList.add('o-layout__cell', 'js--file-multi__folder');
            $folderElement.setAttribute('data-rel', folder);
            $folderElement.innerHTML = subElements;

            if (uploader.$imagesList.firstElementChild) {
                uploader.$imagesList.insertBefore($folderElement, uploader.$imagesList.firstElementChild);
            } else {
                uploader.$imagesList.appendChild($folderElement);
            }
        }
    },

    appendThumbToList: function (folder, $thumb, uploader) {
        var $folderList = uploader.$imagesList.querySelector('.js--file-multi__folder[data-rel="' + folder + '"] .js--file-multi__folder-list');

        if ($folderList) {
            $folderList.appendChild($thumb);
        } else {
            uploader.$imagesList.appendChild($thumb);
        }
    },

    showImagePreview: function (file, uploader, waitStart) {
        var self = this;

        setTimeout(function(){
            window.requestAnimationFrame(function(){
                var folder = self.getFolderFromFile(file);
                var $thumbTemplate = uploader.$imagesList.querySelector('.js--c-plupload__thumb-template');

                if (!uploader.$imagesList.querySelector('[data-file-id="' + file.id + '"]') && file.status !== plupload.DONE) {
                    /**
                     * create folder
                     */
                    self.createFolderView(folder, uploader);

                    // clone the 'template'
                    var $clonedThumb = $thumbTemplate.cloneNode(true);
                    // set attributes and values
                    $clonedThumb.title = file.name;
                    $clonedThumb.dataset.fileId = file.id;
                    $clonedThumb.dataset.loader = $clonedThumb.querySelector('.js--plupload__progress-bar');
                    $clonedThumb.querySelector('.js--c-plupload__filename').innerHTML = file.name;
                    $clonedThumb.querySelector('.js--c-plupload__filesize').innerHTML = self.formatBytes(file.size, 0);
                    var $deleteEntryBtn = $clonedThumb.querySelector('.js--plupload__remove-file');
                    $deleteEntryBtn.addEventListener('click', function (e) {
                        e.stopPropagation(); // because the container has a add-files click event
                        uploader.removeFile(file.id);
                        self.removeThumb(uploader, file);
                    });

                    self.appendThumbToList(folder, $clonedThumb, uploader);

                    // uploader.$imagesList.appendChild($clonedThumb);
                    uploader.$imagesList.classList.add('is-visible');
                    $clonedThumb.classList.remove('u-visuallyhidden', 'js--c-plupload__thumb-template');
                    // Create an instance of the moxie Image object. This utility object provides several means of reading in and loading image data from various sources. Wiki: https://github.com/moxiecode/moxie/wiki/Image
                    var preloader = new moxie.image.Image();
                    // Define the onload BEFORE you execute the load() command as load() does not execute async.
                    preloader.onload = function () {
                        if ((this.width < uploader.$minPixelSize || this.height < uploader.$minPixelSize) && (file.type !== 'image/png')) {
                            $clonedThumb.querySelector('.js--plupload__thumb').classList.add('is-invalid');
                            $clonedThumb.querySelector('.js--c-plupload__filesize').innerHTML = oy.dictionary.upload.resolutionTooLow;
                            uploader.removeFile(file.id);
                        }
                        else if(uploader.$bgimage === 'true' && (this.width !== this.height )) {
                            $clonedThumb.querySelector('.js--plupload__thumb').classList.add('is-invalid');
                            $clonedThumb.querySelector('.js--c-plupload__filesize').innerHTML = oy.dictionary.upload.widthandHeightAreNotTheSame;
                            uploader.removeFile(file.id);
                        }
                        else {
                            $clonedThumb.querySelector('.js--c-plupload__image-dimensions').innerHTML = this.width + ' x ' + this.height;
                        }
                        preloader.embed($clonedThumb.querySelector('.js--c-plupload__thumb__placeholder'), {width:177,height: 118,crop: true});
                    };

                    preloader.onembedded = function() {
                        this.destroy();
                    };

                    preloader.onerror = function() {
                        this.destroy();
                    };

                    // Calling the .getSource() on the file will return an instance of moxie.File, which is a unified file wrapper that can be used across the various runtimes. Wiki: https://github.com/moxiecode/plupload/wiki/File
                    preloader.load(file.getSource());
                }
            });
        }, waitStart);

    },

    getNumberOfThumbsFromFolder: function ($thumb) {
        var $parent = $thumb.closest('.js--file-multi__folder-list');
        var number = 0;
        if ($parent) {
            number = $parent.querySelectorAll('.js--plupload__thumb').length;
        }
        return number;
    },

    getNumberOfThumbsTotal: function ($thumb) {
        var $parent = $thumb.closest('.js--plupload__image-list');
        var number = 0;
        if ($parent) {
            number = $parent.querySelectorAll('.js--plupload__thumb').length;
        }
        return number;
    },

    removeFolderOfThumb: function ($thumb) {
        var $parent = $thumb.closest('.js--file-multi__folder');
        if ($parent) {
            $parent.remove();
        }
    },

    removeThumb: function (uploader, file) {
        var self = this;
        var $thumbWrap = uploader.$imagesList.querySelector('[data-file-id="' + file.id + '"]');
        var $thumb = $thumbWrap.querySelector('.js--plupload__thumb');
        $thumb.classList.add('is-removing');
        $thumb.addEventListener('transitionend', function () { // check if prefixes are needed
            var siblingsTotal = self.getNumberOfThumbsTotal($thumbWrap);
            /**
             * equal or lower than 2 because of currentItem & the template
             */
            if (siblingsTotal <= 2) {
                uploader.$container.classList.remove('has-files');
            }
            var siblings = self.getNumberOfThumbsFromFolder($thumbWrap);
            if (siblings <= 1) {
                self.removeFolderOfThumb($thumbWrap);
            }
            // uploader.removeFile(file);
            $thumbWrap.remove();
        });
    },

    resetFile: function (file) {
        file.status = 1;
        file.percent = 0;
        file.loaded = 0;
    },

    initPluploads: function () {
        var self = this;
        var $pluploads = document.querySelectorAll('.js--plupload');

        for (var i = 0; i < $pluploads.length; ++i) {
            var $plupload = $pluploads[i];
            self.setupPlupload($plupload);
        }
    },

    formatBytes: function (bytes, decimals) {
        if (bytes === 0) {
            return '0 bytes';
        }
        var k = 1000; // or 1024 for binary
        var dm = decimals + 1 || 3;
        var sizes = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        var i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
};


/**
 * Fire ALL the things
 */
window.addEventListener('load', function () {
    oy.form.elements.fileMulti.init();
}, false);
